import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { getAuth, applyActionCode } from "firebase/auth"
import { useLocation } from "react-router-dom"
import { Card, CardContent, Typography, CircularProgress, Container, Stack, Button } from "@mui/material"
import { HomeOutlined } from "@mui/icons-material"
import ResetPassword from "@/features/auth/components/ResetPassword"

const EmailVerification = () => {
  const [message, setMessage] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const location = useLocation()
  const [mode, setMode] = useState<"verifyEmail" | "resetPassword" | null>()
  useEffect(() => {
    const verifyEmail = async () => {
      const auth = getAuth()
      const urlParams = new URLSearchParams(location.search)
      const oobCode = urlParams.get("oobCode")
      const currentMode = urlParams.get("mode") as "verifyEmail" | "resetPassword" | null
      setMode(currentMode)
      if (!oobCode) {
        setMessage("Invalid verification link.")
        setIsLoading(false)
        return
      }

      if (currentMode === "verifyEmail") {
        try {
          await applyActionCode(auth, oobCode)
          setMessage("Email verified successfully!")
          window.location.replace("/")
        } catch (error) {
          setMessage("Error verifying email. Please try again.")
          console.error(error)
        }
      }

      setIsLoading(false)
    }
    verifyEmail()
  }, [location, navigate])

  return (
    <>
      {mode === "resetPassword" && <ResetPassword />}
      {mode === "verifyEmail" && (
        <Container maxWidth="sm">
          <Stack alignItems="center" justifyContent="center" height="100%" spacing={3}>
            <Card variant="outlined" sx={{ p: 4, display: "flex", alignItems: "center", flexDirection: "column" }}>
              <CardContent sx={{ textAlign: "center" }}>
                <Typography variant="h4">Email Verification</Typography>
                {isLoading ? (
                  <CircularProgress sx={{ mt: 2 }} />
                ) : (
                  <Typography variant="body1" sx={{ color: "text.secondary", mt: 2 }}>
                    {message}
                  </Typography>
                )}
              </CardContent>
              <Link to="/">
                <Button variant="contained" color="primary" sx={{ mt: 3 }} endIcon={<HomeOutlined />}>
                  Go Home
                </Button>
              </Link>
            </Card>
          </Stack>
        </Container>
      )}
      {mode !== "resetPassword" && mode !== "verifyEmail" && !isLoading && (
        <Container maxWidth="sm">
          <Stack alignItems="center" justifyContent="center" height="100vh" spacing={3}>
            <Card variant="outlined" sx={{ p: 4, display: "flex", alignItems: "center", flexDirection: "column" }}>
              <CardContent sx={{ textAlign: "center" }}>
                <Typography variant="h5">Invalid Link</Typography>
                <Typography variant="body2" sx={{ color: "text.secondary", mt: 2 }}>
                  This link is invalid or has expired. Please request a new one.
                </Typography>
              </CardContent>
              <Link to="/">
                <Button variant="contained" color="primary" sx={{ mt: 3 }} endIcon={<HomeOutlined />}>
                  Go Home
                </Button>
              </Link>
            </Card>
          </Stack>
        </Container>
      )}
    </>
  )
}

export default EmailVerification
